import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TransactionNatureForm, {
  TransactionNatureFormFields,
} from '../../components/TransactionNature/TransactionNatureForm';
import api from '../../services/api';
import { useAuth } from '../../contexts/auth';

export default function TransactionNaturesNew() {
  const {
    user: { organization },
  } = useAuth();
  const navigate = useNavigate();
  const [formErrors, setFormErrors] = useState({});

  const onSubmit = async (data: TransactionNatureFormFields) => {
    try {
      await api.post(
        `organizations/${organization.id}/transaction-natures`,
        data
      );

      navigate('/transaction-natures');
    } catch (e: any) {
      if (e.response.data.errors) {
        setFormErrors(e.response.data.errors);
      }
    }
  };

  const [formFields, setFormFields] = useState<TransactionNatureFormFields>(
    {} as TransactionNatureFormFields
  );

  return (
    <TransactionNatureForm
      isLoading={1 + 1 === 1}
      title='Nova'
      formFields={formFields}
      formErrors={formErrors}
      onSubmit={onSubmit}
    />
  );
}
